import { createLocalAudioTrack, Track } from 'livekit-client';
/**
 * Обработка звука задаётся явно: createLocalAudioTrack не наследует
 * audioCaptureDefaults комнаты, и без этих ограничений в звонке было эхо.
 */
export const MICROPHONE_CAPTURE_OPTIONS = {
    autoGainControl: true,
    channelCount: 1,
    echoCancellation: true,
    noiseSuppression: true,
};
async function publishMicrophoneIfNeeded(room, track) {
    if (room.localParticipant.getTrackPublication(Track.Source.Microphone)?.track === track)
        return;
    await room.localParticipant.publishTrack(track, { source: Track.Source.Microphone });
}
/**
 * Снять старую дорожку микрофона и опубликовать новую — то же, что делает перезаход во встречу.
 * deviceId передаётся строкой, то есть как предпочтение: если устройство пропало, браузер возьмёт другое.
 */
export async function republishMicrophone(room, previous, deviceId) {
    if (previous) {
        try {
            await room.localParticipant.unpublishTrack(previous, true);
        }
        catch (error) {
            console.warn('Failed to unpublish previous microphone track', error);
        }
        // Safari не отдаёт новую дорожку, пока жива старая
        previous.stop();
    }
    const track = await createLocalAudioTrack({ ...MICROPHONE_CAPTURE_OPTIONS, ...(deviceId ? { deviceId } : {}) });
    try {
        await room.localParticipant.publishTrack(track, { source: Track.Source.Microphone });
    }
    catch (error) {
        track.stop();
        throw error;
    }
    return track;
}
/**
 * Включить микрофон. Принудительный restartTrack перед unmute здесь не нужен и вреден:
 * он гасит рабочую дорожку до getUserMedia, и при ошибке захвата микрофон оставался мёртвым.
 * SDK сам перезахватывает дорожку в unmute(), если она закончилась.
 */
export async function enableMicrophone(room, track, deviceId) {
    if (track) {
        try {
            await track.unmute();
            if (track.mediaStreamTrack.readyState === 'live') {
                await publishMicrophoneIfNeeded(room, track);
                return track;
            }
        }
        catch (error) {
            console.warn('Failed to unmute microphone track, recreating it', error);
        }
    }
    return republishMicrophone(room, track, deviceId);
}
